import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { MediaType } from "@domain/learn/learn-service";

/**
 * Tracks when user leaves the article/video page
 * @param contentType - ARTICLE or VIDEO
 * @param contentId - The document ID
 * @param percentValue - Percent of content viewed (0-100), either scroll percentage or % slides viewed
 */
export const sendAnalyticsEventContentViewed = (
	contentType: MediaType,
	contentId: string,
	percentValue = 0,
): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.CONTENT,
		action: "contentViewed",
		params: [contentType, contentId, percentValue],
	});
};
